// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { CartResult, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

type HandlerType = Handler<
    {
        shouldLoadFullCart?: boolean;
        replaceCart?: boolean;
        getPromotions?: boolean;
        getCartLines?: boolean;
        getCostCodes?: boolean;
    } & HasOnSuccess,
    {
        apiParameter: GetCartApiParameter;
        apiResult: CartResult;
        needFullCart: boolean;
    }
>;

// this function is called on update and delete so adding additional expands once rather than changing 3 other files
export const XngExpandApiParameter: HandlerType = (props: any) => {
    const ourExpand = ["restrictions", "properties", "validation", "paymentOptions"];
    // cartLines passed from OOTB and depend on getCartLines parameter
    const cartSettings = props.getState().context.settings.settingsCollection.cartSettings;
    const pageType = getCurrentPage(props.getState()).type;

    props.apiParameter.expand = [...new Set([...props.apiParameter.expand, ...ourExpand])];
    const timestamp = `time${new Date().getTime()}`;

    // XNG-Change make sure we expand tax if needed on the minicart.
    if (props.needFullCart) {
        props.apiParameter.forceRecalculation = true;
        props.apiParameter.expand = [...new Set([...(props.apiParameter.expand || []), "carriers", "costCodes"])];
    } else if (cartSettings.showTaxAndShipping) {
        props.apiParameter.expand.push("tax");
    } else {
        props.apiParameter.expand = props.apiParameter.expand.filter((expand: string) => expand !== "shipping");
    }
    // <XNG-Change> remove carriers on the cart page
    if (pageType === "CartPage") {
        props.apiParameter.expand = props.apiParameter.expand.filter((expand: string) => expand !== "carriers");
    }
    // </XNG-Change>
    props.apiParameter.expand?.push(timestamp);
};

addToChainAfter(chain, PopulateApiParameter, XngExpandApiParameter);
